<template>
    <div class="pb-4 pt-2" data-cy="container_serial_item">
        <div
            class="px-4  grid grid-cols-3 text-center font-bold select-none"
            v-show="isShowCode"
            data-cy="container_serial_item_tabs"
        >
            <div
                class="border py-5px text-15 leading-none cursor-pointer font-bold font-main-bold"
                :class="[serialType == 'QR_CODE' ? classActiveTab : 'border-transparent text-dark-10']"
                @click="changeTab('QR_CODE')"
                data-cy="btn_serial_item_tab_qr_code"
            >{{ lbl.serial.qr_code }}</div>

            <div
                class="border  py-5px text-15 leading-none cursor-pointer font-bold font-main-bold"
                :class="[serialType == 'CODE' ? classActiveTab : 'border-transparent text-dark-10']"
                @click="changeTab('CODE')"
                data-cy="btn_serial_item_tab_code"
            >{{ lbl.serial.code }}</div>

            <div
                class="border  py-5px text-15 leading-none cursor-pointer font-bold font-main-bold"
                :class="[serialType == 'CODE_128' ? classActiveTab : 'border-transparent text-dark-10']"
                @click="changeTab('CODE_128')"
                data-cy="btn_serial_item_tab_barcode"
            >{{ lbl.serial.barcode }}</div>
        </div>

        <div class="flex justify-center items-center wrap-code">
            <div v-show="serialType == 'QR_CODE'" data-cy="container_serial_item_qr_code_wrap">
                <VueQrcode :value="serial" :options="qrOption" data-cy="component_serial_item_qrcode"></VueQrcode>
            </div>
            <div v-show="serialType == 'CODE_128'" data-cy="container_serial_item_barcode_wrap">
                <VueBarcode :value="serial" :options="barcodeOption" data-cy="component_serial_item_barcode"></VueBarcode>
            </div>
            <div v-show="serialType == 'CODE'" data-cy="container_serial_item_code_wrap">
                <div class="text-38 font-medium font-main-medium tracking-widest" data-cy="text_serial_item_code_value">{{ serial }}</div>
                <!-- <button
                v-clipboard:copy="serial"
                v-clipboard:success="onCopy">Copy</button>-->
            </div>
        </div>
    </div>
</template>
<script>
import LocaleMixin from "@/mixin/LocaleMixin.js";
//lib
import VueBarcode from '@chenfengyuan/vue-barcode';
import VueQrcode from '@chenfengyuan/vue-qrcode';

export default {
    name: "Serial",
    mixins: [LocaleMixin],
    components: {
        VueBarcode,
        VueQrcode,
    },
    props: {
        serialModel: Object,
    },
    data: function () {
        return {
            serialType: 'CODE', // CODE, QR_CODE, CODE_128
            classActiveTab: 'border-dark-8 text-dark-9 rounded-5px',

            isExpired: false,
            isLoaded: false,
            isShowCode: true,
            isTabLock: false,
            privilegeMsg: '',
            serial: '',

            qrOption: {
                width: 160,
                margin: 0,
            },
            barcodeOption: {
                height: 70,
                displayValue: false,
                lineColor: '#000000',
                width: 2,
            },
        };
    },
    created: function () {
        this.initial();
    },
    methods: {
        initial: function () {
            if (!this.serialModel.serial) {
                return;
            }

            this.isExpired = false;
            this.serial = this.serialModel.serial;
            switch (this.serialModel.barcode) {
                case 'CODE_128':
                    this.serialType = 'CODE_128';
                    break;
                case 'QR_CODE':
                    this.serialType = 'QR_CODE';
                    break;
                default:
                    this.serialType = 'CODE';
                    break;
            }

            if (this.serialModel.barcode && this.serialModel.barcode.toLowerCase() == 'none' && this.serialModel.privilegeMessage) {
                this.isShowCode = false;
            }
        },

        changeTab: function (type) {
            if (this.isTabLock) return;

            this.serialType = type;
        },

        setSerialExpire: function () {
            this.serial = "XXXXXX";
            this.isExpired = true;
            this.isTabLock = true;
            this.serialType = "CODE";
        },
    },
}
</script>
<style lang="scss" scoped>
.wrap-code {
    height: 200px;
}
</style>
